(function() {
  function init() {
    var rows = document.querySelectorAll('.noxor-why-us__row--hidden');
    if (!rows.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var index = Array.from(rows).indexOf(entry.target);
          setTimeout(function() {
            entry.target.classList.remove('noxor-why-us__row--hidden');
            entry.target.classList.add('noxor-why-us__row--visible');
          }, index * 200);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    rows.forEach(function(row) { observer.observe(row); });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
